import * as React from 'react';
import { useState } from 'react';
import Slider from 'rc-slider';
import styled, { css } from 'styled-components';
import { rem, rgba } from 'polished';
import { __ } from 'react-i18n';
import { FlexColCenter, FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { Table, TableRow, TableTd, TableTh } from '../General/Table';
import { SellersListItem } from './SellersListItem';

interface Props {
  sellers: any;
  hasSortiment?: boolean;
}

export function SellersList({ sellers, hasSortiment }: Props) {
  const rows: JSX.Element[] = [];
  for (const [nameOfSeller, shops] of Object.entries(sellers)) {
    const item = (
      <SellersListItem
        key={nameOfSeller}
        shops={shops}
        nameOfSeller={nameOfSeller}
        hasSortiment={hasSortiment}
      />
    );
    rows.push(item);
  }

  return (
    <>
      <Wrapper>
        <StyledTable>
          <thead>
            <tr>
              <StyledTableTh>{__('Predajca')}</StyledTableTh>
              <StyledTableTh>{__('Miesto')}</StyledTableTh>
              {hasSortiment && <StyledTableTh>{__('Sortiment')}</StyledTableTh>}
              <StyledTableTh>{__('Web')}</StyledTableTh>
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </StyledTable>
      </Wrapper>
      {Object.entries(sellers).length === 0 && (
        <NoData>
          {__('Nenašli sa žiadne predajne podľa hľadaného mesta.')}
        </NoData>
      )}
    </>
  );
}

const NoData = styled.div`
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 1.5rem;
  margin-bottom: ${rem(56)};
`;

const Wrapper = styled(FlexRowCenter)`
  margin-bottom: ${rem(56)};
`;

const StyledTableTh = styled(TableTh)`
  font-weight: 500;
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  border-bottom: 0;
  padding: ${rem(18)} ${rem(24)};
  width: 25vw;
  max-width: 25vw !important;
`;

const tdLikeCss = css`
  font-size: ${rem(16)};
  line-height: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  padding: ${rem(18)} ${rem(24)};
  background: ${({ theme }) => rgba(theme.colors.white, 1)};
`;

const StrongTableTd = styled(TableTd)`
  ${tdLikeCss};
  font-weight: 500;
`;

const StyledTableTd = styled(TableTd)`
  ${tdLikeCss};
  font-weight: 400;
`;

const StyledLink = styled.a`
  ${tdLikeCss};
  color: #1e398d;
  text-decoration: underline;
  padding: 0;
`;

const SubTableRow = styled(TableRow)`
  td {
    background: ${({ theme }) => rgba(theme.colors.white, 0.32)};
  }
`;

const StyledTable = styled(Table)`
  border-spacing: 0 ${rem(2)};

  thead {
    background: ${({ theme }) => rgba(theme.colors.white, 0.32)};
    border-bottom: none;
  }

  tr {
    height: ${rem(56)};
  }

  tbody {
    background: transparent;
  }
`;
